import { useCallback } from 'react';
import { StaticCanvas } from 'fabric';
import { initAllSobreimpresos } from './hydrate';

export const useSobreimpresoHydration = (canvas: StaticCanvas | null) =>
  useCallback(() => {
    if (!canvas) return;
    initAllSobreimpresos(canvas);
  }, [canvas]);
